/**
* DevExpress Dashboard (_list-box-item.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { filterElementItemBaseSerializationInfo, showAllValue } from './_filter-element-item-base';
export let listBoxType = {
    propertyName: 'listBoxType', modelName: '@ListBoxType', displayName: 'DashboardWebStringId.FilterItem.Type', defaultVal: 'Checked', simpleFormAdapterItem: 'buttonGroupEditor', values: {
        'Checked': 'DashboardWebStringId.FilterItem.Type.Checked',
        'Radio': 'DashboardWebStringId.FilterItem.Type.Radio'
    }
};
export let listBoxDashboardItemSerializationsInfo = filterElementItemBaseSerializationInfo.concat([listBoxType, showAllValue]);
